export const nativePostMessage = (message: string) => {
  if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appInterface) {
    window.webkit.messageHandlers.appInterface.postMessage(message)
  }
  if (window.appInterface) {
    window.appInterface.postMessage(message)
  }
}

export class NativeMessaging {
  /**
   * Send a message to the native app
   * @param message - The message string to send
   */
  static sendMessage(message: string): void {
    nativePostMessage(message)
  }

  /**
   * Check if native messaging is available
   * @returns boolean indicating if native messaging is supported
   */
  static isAvailable(): boolean {
    return !!(window.webkit?.messageHandlers?.appInterface || window.appInterface)
  }

  /**
   * Get the platform type
   * @returns 'ios' | 'android' | 'web'
   */
  static getPlatform(): "ios" | "android" | "web" {
    if (window.webkit?.messageHandlers?.appInterface) {
      return "ios"
    } else if (window.appInterface) {
      return "android"
    }
    return "web"
  }
}
